import React from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from '@reach/router';
import FormHeader from 'components/FormHeader';
import { RFC } from 'state/StateTypes';

const UpgradeAccount: RFC<RouteComponentProps> = () => {
   return (
      <Container>
         <Header>PURCHASE PREMIUM SUBSCRIPTION</Header>
         <TopSection>
            <img src="https://via.placeholder.com/300" alt="" />
            <Text>
               Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptates minima reiciendis impedit iure. Exercitationem sapiente, quae
               eligendi incidunt nam soluta?
            </Text>
         </TopSection>
         <BottomSection>
            <img src="https://via.placeholder.com/300" alt="" />
            <Text>
               Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptates minima reiciendis impedit iure. Exercitationem sapiente, quae
               eligendi incidunt nam soluta?
            </Text>
         </BottomSection>
      </Container>
   );
};

export default UpgradeAccount;

const Container = styled.div`
   width: 70%;
   padding: 15px;
   margin: 1em auto;
`;

const Header = styled(FormHeader)`
   text-align: center;
   margin: 0 auto;
`;

const TopSection = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
`;

const BottomSection = styled(TopSection)`
   flex-direction: row-reverse;
`;

const Text = styled.p`
   display: inline-block;
   color: ${({ theme }) => theme.primaryBlueDark};
   margin: 0 8px;
`;
